import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import {
    saveAuthToCookie,
    saveUserToCookie,
    getTokenFromCookie,
    getUserFromCookie,
    deleteCookie,
} from '@/utils/auth/cookies';

import spinnerStore from './modules/common/spinnerStore';
import elaStore from './modules/ela/elaStore';
import codeStore from './modules/code/codeStore';
import dialogStore from './modules/dialog/dialogStore';
import menuStore from './modules/common/menuStore';

import createPersistedState from 'vuex-persistedstate';

export default new Vuex.Store({
    state: {
        // 쿠키와 연결됨
        userData: getUserFromCookie() || null,
        authToken: getTokenFromCookie('authToken') || '',
        userKey: getTokenFromCookie('userKey') || '',
        sessionToken: getTokenFromCookie('sessionToken') || '',
        // 헤더에 담을 토큰
        tokenObj: {},
        initializedUserData: {
            ssnEnterCd: '',
            ssnSabun: '',
            ssnName: '',
            ssnOrgCd: '',
            id: '',
            profileImgPath: '',
            orgChiefYn: '',
            authGroup: '',
            empInfoCardYn: '',
            ssnStatusCd: '',
        },

        LBS_FLAG: false,
        LBS_TEST_DATA: '출퇴근 불가 지역!',

        BOTTOM_NAV_FLAG: true,

        // css
        // 공통 컴포넌트 높이
        header: 56,
        title: 54,
        tab: 48,
        search: 96,
        bottomBtn: 96,
        bottomNavIos: 82,
        bottomNavAnd: 62,
        moreBtn: 38,

        schClsfiCd: '',
        famRshipCd: '',
        code: '',
        code1: '',
        applCd: '',
        birthDay: '',
        famSeq: '',
        codeNm: '',
        tgtName: '',
        limitTerm: '',
        usedDaysBefore: '',
        caDays: '',
        returnYmd: '',
        applType: '',
        applSeq: '',
        orgApplSeq: '',
        authPg: '',
        seqNo: '',
        fileSeq: 0,
        workTypeCd: '',
        note: '',
        note1: '',
        workTypeNm: '',
        replaceYmd: '',
        holReplaceData: null,
        holReplacePeriodData: null,
        workScheduleTimeData: null,
        workYmd: '',
        // secondAuthenticate: [],
        secondAuthenticate: false,
        showSecondAuthenticate: false,
        redirectUrl: '',
        secondAuthenticateAfterType: 'page',
        note2: '',
        dayGubunCd: '',
        dayGubunNm: '',
        phoneNo: '',
        date: '',
        workScheduleTimeSaveOrg: [],
        workScheduleTimeSaveUpd: [],
        item: [],
        surveyAnswer: [],
        idx: 0,
        params: [],
        vacationGntGubunMenu: [],
        vacationHolidayCnt: [],
        gnt: [],
        useTargetAnnual: [],
        famPerDay: 0,
        famAddDay: 0,
        remainDaysBefore: 0,
        refSdate: '',
        refEdate: '',
        useDay: 0,
        parlevReturnYmd: '',
        vacationAtOnceTimKey: '',
    },
    getters: {
        GET_USER_DATA(state) {
            return state.userData;
        },
        IS_AUTHENTICATED(state) {
            return (!!state.authToken && !!state.userKey && !!state.sessionToken
                // && state.userData !== null // ..
            );
        },
        GET_AUTH_TOKEN(state) {
            return state.authToken;
        },
        GET_USER_KEY(state) {
            return state.userKey;
        },
        GET_SESSION_TOKEN(state) {
            return state.sessionToken;
        },
        GET_TOKEN_OBJ(state) {
            return state.tokenObj;
        },
        GET_LBS_FLAG(state) {
            return state.LBS_FLAG;
        },
        GET_LBS_TEST_DATA(state) {
            return state.LBS_TEST_DATA;
        },
        GET_BOTTOM_NAV_FLAG(state) {
            return state.BOTTOM_NAV_FLAG;
        },
        IS_ANDROID() {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return userAgent.indexOf('android') > -1;
        },
        IS_IOS() {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1;
        },
        IS_WEB() {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return (
                userAgent.indexOf('iphone') === -1 &&
                userAgent.indexOf('ipad') === -1 &&
                userAgent.indexOf('android') === -1
            );
        },
        GET_SCHCLSFI_CD(state) {
            return state.schClsfiCd;
        },
        GET_FAMRSHIPCD_CD(state) {
            return state.famRshipCd;
        },
        GET_CODE(state) {
            return state.code;
        },
        GET_CODE1(state) {
            return state.code1;
        },
        GET_CODE_NM(state) {
            return state.codeNm;
        },
        GET_APPL_CD(state) {
            return state.applCd;
        },
        GET_BIRTHDAY(state) {
            return state.birthDay;
        },
        GET_FAM_SEQ(state) {
            return state.famSeq;
        },
        GET_TGT_NAME(state) {
            return state.tgtName;
        },
        GET_LIMIT_TERM(state) {
            return state.limitTerm;
        },
        GET_USED_DAYS_BEFORE(state) {
            return state.usedDaysBefore;
        },
        GET_CA_DAYS(state) {
            return state.caDays;
        },
        GET_RETURNYMD(state) {
            return state.returnYmd;
        },
        GET_APPL_TYPE(state) {
            return state.applType;
        },
        GET_APPL_SEQ(state) {
            return state.applSeq;
        },
        GET_AUTHPG(state) {
            return state.authPg;
        },
        GET_SEQ_NO(state) {
            return state.seqNo;
        },
        GET_FILE_SEQ(state) {
            return state.fileSeq;
        },
        GET_ORG_APPL_SEQ(state) {
            return state.orgApplSeq;
        },
        GET_WORK_TYPE_CD(state) {
            return state.workTypeCd;
        },
        GET_WORK_TYPE_NM(state) {
            return state.workTypeNm;
        },
        GET_DATE(state) {
            return state.date;
        },
        GET_PHONE_NO(state) {
            return state.phoneNo;
        },
        GET_NOTE(state) {
            return state.note;
        },
        GET_NOTE1(state) {
            return state.note1;
        },
        GET_NOTE2(state) {
            return state.note2;
        },
        GET_REPLACE_YMD(state) {
            return state.replaceYmd;
        },
        GET_HOL_REPLACE_DATA(state) {
            return state.holReplaceData;
        },
        GET_HOL_REPLACE_PERIOD_DATA(state) {
            return state.holReplacePeriodData;
        },
        GET_WORK_SCHEDULE_TIME_DATA(state) {
            return state.workScheduleTimeData;
        },
        GET_WORK_YMD(state) {
            return state.workYmd;
        },
        GET_SECOND_AUTHENTICATE(state) {
            return state.secondAuthenticate;
        },
        GET_SHOW_SECOND_AUTHENTICATE(state) {
            return state.showSecondAuthenticate;
        },
        GET_REDIRECT_URL(state) {
            return state.redirectUrl;
        },
        GET_SECOND_AUTHENTICATE_AFTER_TYPE(state) {
            return state.secondAuthenticateAfterType;
        },
        GET_DAY_GUBUN_CD(state) {
            return state.dayGubunCd;
        },
        GET_DAY_GUBUN_NM(state) {
            return state.dayGubunNm;
        },
        GET_ITEM(state) {
            return state.item;
        },
        GET_SURVEY_ANSWER(state) {
            return state.surveyAnswer;
        },
        GET_IDX(state) {
            return state.idx;
        },
        GET_PARAMS(state) {
            return state.params;
        },
        GET_VACATION_GNT_GUBUN_MENU(state) {
            return state.vacationGntGubunMenu;
        },
        GET_VACATION_HOLIDAY_CNT(state) {
            return state.vacationHolidayCnt;
        },
        GET_GNT(state) {
            return state.gnt;
        },
        GET_PER_DAY(state) {
            return state.famPerDay;
        },
        GET_ADD_DAY(state) {
            return state.famAddDay;
        },
        GET_USE_DAY(state) {
            return state.useDay;
        },
        GET_REMAIN_DAYS_BEFORE(state) {
            return state.remainDaysBefore;
        },
        GET_ADD_LIMIT_TERM(state) {
            return state.addLimitTerm;
        },
        GET_USER_TARGET_ANNUAL(state) {
            return state.useTargetAnnual;
        },
        GET_WORK_SCHEDULE_TIME_SAVE_ORG(state) {
            return state.workScheduleTimeSaveOrg;
        },
        GET_WORK_SCHEDULE_TIME_SAVE_UPD(state) {
            return state.workScheduleTimeSaveUpd;
        },
        GET_REF_SDATE(state) {
            return state.refSdate;
        },
        GET_REF_EDATE(state) {
            return state.refEdate;
        },
        GET_PARLEV_RETURN_YMD(state) {
            return state.parlevReturnYmd
        },
        GET_TIM_APPL_SEQ(state) {
            return state.vacationAtOnceTimKey;
        },
        /* 스크롤 영역 제외 높이 계산 */
        // 헤더 + 하단 네비게이션
        HEIGHT_BOTTOM_NAV(state, getters) {
            if (getters.IS_IOS) {
                return state.header + state.bottomNavIos;
            } else {
                return state.header + state.bottomNavAnd;
            }
        },
        // 헤더 + 타이틀
        HEIGHT_TITLE(state) {
            return state.header + state.title;
        },
        // 헤더 + 탭
        HEIGHT_TAB(state) {
            return state.header + state.tab;
        },
        // 탭 + 검색어
        HEIGHT_TAB_SEARCH(state) {
            return state.tab + state.search + 5; // margin
        },
        // 헤더 + 타이틀 + 바텀네브
        HEIGHT_TITLE_BOTTOM_NAV(state, getters) {
            return getters.HEIGHT_BOTTOM_NAV + state.title;
        },
        // 헤더 + 타이틀 + 바텀버튼
        HEIGHT_TITLE_BOTTOM_BTN(state, getters) {
            return getters.HEIGHT_TITLE + state.bottomBtn;
        },
        // 헤더 + 바텀버튼
        HEIGHT_BOTTOM_BTN(state) {
            return state.header + state.bottomBtn;
        },
    },
    mutations: {
        setToken(state, data) {
            state.authToken = data.authToken;
            state.userKey = data.userKey;
            state.sessionToken = data.sessionToken;
            saveAuthToCookie(data);
        },
        setTokenObj(state, data) {
            // console.log('******************store setTokenObj***********************');
            // console.log('authToken : ' + data.authToken);
            // console.log('userKey : ' + data.userKey);
            // console.log('sessionToken : ' + data.sessionToken);
            // console.log('ssnEnterCd : ' + data.ssnEnterCd);
            // console.log('ssnSabun : ' + data.ssnSabun);
            // console.log('ssnName : ' + data.ssnName);
            // console.log('ssnOrgCd : ' + data.ssnOrgCd);
            // console.log('id : ' + data.id);
            // console.log('profileImgPath : ' + data.profileImgPath);
            // console.log('orgChiefYn : ' + data.orgChiefYn);
            // console.log('authGroup : ' + data.authGroup);
            // console.log('empInfoCardYn : ' + data.empInfoCardYn);
            // console.log('ssnStatusCd : ' + data.ssnStatusCd);
            // console.log('setTokenObj : ' + JSON.stringify(data));
            // console.log('**********************************************************');
            state.tokenObj = {
                authToken: data.authToken,
                userKey: data.userKey,
                sessionToken: data.sessionToken,
                userData: {
                    ssnEnterCd: data.ssnEnterCd,
                    ssnSabun: data.ssnSabun,
                    ssnName: data.ssnName,
                    ssnOrgCd: data.ssnOrgCd,
                    id: data.id,
                    profileImgPath: data.profileImgPath,
                    orgChiefYn: data.orgChiefYn,
                    authGroup: data.authGroup,
                    empInfoCardYn: data.empInfoCardYn,
                    ssnStatusCd: data.ssnStatusCd,
                },
            };
        },
        setUserData(state, userObj) {
            // console.log('******************store setUserData***********************');
            // console.log('ssnEnterCd : ' + userObj.ssnEnterCd);
            // console.log('ssnSabun : ' + userObj.ssnSabun);
            // console.log('ssnName : ' + userObj.ssnName);
            // console.log('ssnOrgCd : ' + userObj.ssnOrgCd);
            // console.log('id : ' + userObj.id);
            // console.log('profileImgPath : ' + userObj.profileImgPath);
            // console.log('orgChiefYn : ' + userObj.orgChiefYn);
            // console.log('authGroup : ' + userObj.authGroup);
            // console.log('userObj : ' + JSON.stringify(userObj));
            // console.log('user object : ', userObj);
            // console.log('**********************************************************');

            const userData = {
                //20240118 : 초기값 임의 설정
                ssnEnterCd: userObj.ssnEnterCd,
                ssnSabun: userObj.ssnSabun,
                ssnName: userObj.ssnName,
                //ssnEnterCd: 'HR',
                //ssnSabun: '101006',
                //ssnSabun: '231116',
                //ssnName: '테스터',
                ssnOrgCd: userObj.ssnOrgCd,
                id: userObj.id,
                profileImgPath: userObj.profileImgPath,
                //orgChiefYn: userObj.orgChiefYn,
                orgChiefYn: 'N',
                //authGroup: userObj.authGroup,
                authGroup: '20',
                empInfoCardYn: userObj.empInfoCardYn,
                ssnStatusCd: userObj.statusCd,
            };
            state.userData = userData;
            saveUserToCookie(encodeURIComponent(JSON.stringify(userData)));
        },
        cleanToken(state) {
            state.authToken = '';
            state.userKey = '';
            state.sessionToken = '';
            state.userData = state.initializedUserData;
            deleteCookie('authToken');
            deleteCookie('userKey');
            deleteCookie('sessionToken');
            deleteCookie('userData');
        },
        schClsfiCd(state, data) {
            state.schClsfiCd = data;
        },
        SET_FAMRSHIPCD_CD(state, data) {
            state.famRshipCd = data;
        },
        SET_CODE(state, data) {
            state.code = data;
        },
        SET_CODE1(state, data) {
            state.code1 = data;
        },
        SET_CODE_NM(state, data) {
            state.codeNm = data;
        },
        SET_BIRTHDAY(state, data) {
            state.birthDay = data;
        },
        SET_FAM_SEQ(state, data) {
            state.famSeq = data;
        },
        SET_TGT_NAME(state, data) {
            state.tgtName = data;
        },
        SET_APPL_CD(state, data) {
            state.applCd = data;
        },
        SET_LIMIT_TERM(state, data) {
            state.limitTerm = data;
        },
        SET_USED_DAYS_BEFORE(state, data) {
            state.usedDaysBefore = data;
        },
        SET_CA_DAYS(state, data) {
            state.caDays = data;
        },
        SET_RETURNYMD(state, data) {
            state.returnYmd = data;
        },
        SET_PARLEV_RETURN_YMD(state, data) {
            state.parlevReturnYmd = data;
        },
        SET_APPL_TYPE(state, data) {
            state.applType = data;
        },
        SET_APPL_SEQ(state, data) {
            state.applSeq = data;
        },
        SET_ORG_APPL_SEQ(state, data) {
            state.orgApplSeq = data;
        },
        SET_AUTHPG(state, data) {
            state.authPg = data;
        },
        SET_SEQ_NO(state, data) {
            state.seqNo = data;
        },
        SET_FILE_SEQ(state, data) {
            state.fileSeq = data;
        },
        SET_WORK_TYPE_CD(state, data) {
            state.workTypeCd = data;
        },
        SET_WORK_TYPE_NM(state, data) {
            state.workTypeNm = data;
        },
        SET_DATE(state, data) {
            state.date = data;
        },
        SET_PHONE_NO(state, data) {
            state.phoneNo = data;
        },
        SET_NOTE(state, data) {
            state.note = data;
        },
        SET_NOTE1(state, data) {
            state.note1 = data;
        },
        SET_NOTE2(state, data) {
            state.note2 = data;
        },
        SET_REPLACE_YMD(state, data) {
            state.replaceYmd = data;
        },
        SET_WORK_YMD(state, data) {
            state.workYmd = data;
        },
        SET_SECOND_AUTHENTICATE(state, data) {
            // state.secondAuthenticate.push(data);
            // let setArr = new Set(state.secondAuthenticate);
            // state.secondAuthenticate = [...setArr];
            state.secondAuthenticate = data;
        },
        SET_REDIRECT_URL(state, data) {
            state.redirectUrl = data;
        },
        SET_SHOW_SECOND_AUTHENTICATE(state, data) {
            state.showSecondAuthenticate = data;
        },
        SET_SECOND_AUTHENTICATE_AFTER_TYPE(state, data) {
            state.secondAuthenticateAfterType = data;
        },
        SET_DAY_GUBUN_CD(state, data) {
            state.dayGubunCd = data;
        },
        SET_DAY_GUBUN_NM(state, data) {
            state.dayGubunNm = data;
        },
        SET_ITEM(state, data) {
            state.item = data;
        },
        SET_SURVEY_ANSWER(state, data) {
            state.surveyAnswer = data;
        },
        SET_IDX(state, data) {
            state.idx = data;
        },
        SET_WORK_SCHEDULE_TIME_SAVE_ORG(state, data) {
            state.workScheduleTimeSaveOrg = data;
        },
        SET_WORK_SCHEDULE_TIME_SAVE_UPD(state, data) {
            state.workScheduleTimeSaveUpd = data;
        },
        SET_PARAMS(state, data) {
            state.params = data;
        },
        SET_VACATION_GNT_GUBUN_MENU(state, data) {
            state.vacationGntGubunMenu = data;
        },
        SET_VACATION_HOLIDAY_CNT(state, data) {
            state.vacationHolidayCnt = data;
        },
        SET_GNT(state, data) {
            state.gnt = data;
        },
        SET_PER_DAY(state, data) {
            state.famPerDay = data;
        },
        SET_ADD_DAY(state, data) {
            state.famAddDay = data;
        },
        SET_REF_SDATE(state, data) {
            state.refSdate = data;
        },
        SET_REF_EDATE(state, data) {
            state.refEdate = data;
        },
        SET_USE_DAY(state, data) {
            state.useDay = data;
        },
        SET_REMAIN_DAYS_BEFORE(state, data) {
            state.remainDaysBefore = data;
        },
        SET_ADD_LIMIT_TERM(state, data) {
            state.addLimitTerm = data;
        },
        SET_USER_TARGET_ANNUAL(state, data) {
            state.useTargetAnnual = data;
        },
        setHolReplaceParam(state, obj) {
            const holReplaceData = {
                workOrgCd: obj.workOrgCd,
                applGubun: obj.applGubun,
                bfTimeCd: obj.bfTimeCd,
                bfTimeNm: obj.bfTimeNm,
                startDate: obj.startDate,
                endDate: obj.endDate,
                wWorkYmd: obj.wWorkYmd,
            };

            state.holReplaceData = holReplaceData;
        },
        setHolReplacePeriodParam(state, obj) {
            const holReplacePeriodData = {
                replaceBfTimeCd: obj.replaceBfTimeCd,
                replaceBfTimeNm: obj.replaceBfTimeNm,
                getBfTimeGb: obj.getBfTimeGb,
                replaceWorkOrgCd: obj.replaceWorkOrgCd,
            };

            state.holReplacePeriodData = holReplacePeriodData;
        },
        setWorkScheduleTimeParam(state, obj) {
            const workScheduleTimeData = {
                workGrpCd: obj.workGrpCd,
                workOrgCd: obj.workOrgCd,
                workOrgNm: obj.workOrgNm,
                intervalCd: obj.intervalCd,
                termGubun: obj.termGubun,
                workType: obj.workType,
            };

            state.workScheduleTimeData = workScheduleTimeData;
        },
        SET_LBS_FLAG(state, data) {
            state.LBS_FLAG = data;
        },
        SET_LBS_TEST_DATA(state, data) {
            state.LBS_TEST_DATA = data;
        },
        SET_BOTTOM_NAV_FLAG(state, data) {
            state.BOTTOM_NAV_FLAG = data;
        },
        SET_STATE_TOKEN_FROM_COOKIE(state) {
            state.userData = getUserFromCookie();
            state.authToken = getTokenFromCookie('authToken');
            state.userKey = getTokenFromCookie('userKey');
            state.sessionToken = getTokenFromCookie('sessionToken');
            state.tokenObj = {
                authToken: getTokenFromCookie('authToken'),
                userKey: getTokenFromCookie('userKey'),
                sessionToken: getTokenFromCookie('sessionToken'),
                userData: getUserFromCookie(),
            };
        },
        SET_TIM_APPL_SEQ(state, data) {
            state.vacationAtOnceTimKey = data;
        },
        // 테스트용 0914
        RESET_STATE_TOKEN(state) {
            state.authToken = '';
            state.userKey = '';
            state.sessionToken = '';
            state.tokenObj = {};
            state.userData = state.initializedUserData;
        },
    },
    actions: {},
    modules: {
        SPINNER: spinnerStore,
        MENU: menuStore,
        ELA: elaStore,
        CODE: codeStore,
        DIALOG: dialogStore,
    },
    //store 정보를 local storage에 저장
    //새로고침시 store정보가 날아가서 사용.
    //추후 보안관련 제거해야하는지 고민
    plugins: [createPersistedState()],
});